export default {
  action: 'Művelet',
  actionBlockedDueToDuplicateUuid:
    'Művelet blokkolva a duplikált eszköz-UUID miatt',
  active: 'Aktív',
  add: 'Hozzáadás',
  addAnotherIp: 'Újabb IP hozzáadása',
  addDeviceHeaderwoSuite: 'Ezközök hozzáadása: {{screen}}',
  addDevices: 'Ezköz hozzáadása',
  addIp: 'IP hozzáadása',
  addIPAddress: 'IP-cím hozzáadása',
  addIpHeader: 'IP-cím hozzáadása: {{screen}}',
  addRole: 'Szerepkör hozzáadása',
  addSuite: 'Suite hozzáadása',
  addSuiteHeader: 'Suite hozzáadása: {{screen}} - {{suite}} Suite',
  adminRoleWillHaveFullAccess:
    'Az Adminisztrátori szerepkör teljes hozzáféréssel rendelkezik',
  all: 'Összes',
  and: 'és',
  applianceStatus: 'Készülék állapota',
  apply: 'Alkalmaz',
  assignedToDevice: 'Ezközhöz rendelve',
  availableDevices: 'Elérhető eszközök',
  bookingDate: 'Foglalási dátum',
  bookingRef: 'Foglalási hivatkozás',
  bulkEditScreenIPs: 'Képernyő IP-k tömeges szerkesztése',
  bulkHeadingMsg:
    'Az itteni IP-módosítások minden társított képernyőeszközön tükröződnek.',
  cancel: 'Mégsem',
  ccEmails: 'CC e-mailek',
  certificateAutoSync: 'Tanúsítvány automatikus szinkronizálása',
  certificateExpired: 'Tanúsítvány lejárt',
  certificateForAllDevicesMustBeValid:
    'Minden eszköz tanúsítványának érvényesnek kell lennie',
  certificateNotAvailable:
    'Eszköztanúsítvány nem érhető el ehhez a sorozatszámhoz.',
  certificateNotValid: 'A tanúsítvány nem érvényes',
  chain: 'LÁNC',
  chainSmall: 'Lánc',
  changesSavedSuccessfully: 'A módosítások sikeresen mentve',
  clear: 'Törlés',
  clearAll: 'Összes törlése',
  clearAllSmall: 'Összes törlése',
  clearSelection: 'Kijelölés törlése',
  collapseAll: 'Összes összecsukása',
  common: {
    confirm: 'Megerősítés',
  },
  composition: 'Kompozíció',
  compositionCount_one: 'Kompozíció (1)',
  compositionCount_other: 'Kompozíciók ({{count}})',
  compositionDetails: 'Kompozíció részletei',
  compositionName: 'Kompozíció neve',
  confirmDelete: 'Törlés megerősítése',
  confirmDeleteIP: 'Biztosan törölni szeretné a(z) {{ip}} IP-címet?',
  confirmDeleteIPAssigned:
    'Ez az IP jelenleg ki van rendelve, és lekapcsolódik az eszközről: {{deviceInfo}} itt: {{location}}.',
  confirmDeleteSuite:
    'Biztosan törölni szeretné a(z) {{screen_name}} - Suite {{suite_number}} elemet? Kérjük, válasszon egy megfelelő lehetőséget a folytatáshoz.',
  content: 'Tartalom',
  contentDetails: 'Tartalom részletei',
  copyLink: 'Hivatkozás másolása',
  countTheatres_one: '1 Mozi',
  countTheatres_other: '{{count}} Mozi',
  cplMarkers: 'CPL jelölők',
  create: 'Létrehozás',
  createdOn: 'Létrehozva',
  creditOffset: 'Jóváírás elszámolása',
  creditsOffset: 'Kredit eltolás',
  dcpStatusTitle: 'DCP állapota',
  deactivatedUser: 'Deaktivált felhasználó',
  delete: 'Törlés',
  deleteIp: 'IP törlése',
  deleteSuite: 'Suite törlése',
  deleteTheatreGroup: 'Mozicsoport törlése',
  deleteTheatreGroupConfirmation:
    'Biztosan törölni szeretné a(z) {{groupName}} csoportot? Ez a művelet végleges és nem vonható vissza.',
  deleteTheatreWarningMessage:
    'A törlés befolyásolja a hozzáférésüket. Biztosan folytatni szeretné?',
  details: 'Részletek',
  deviceWillBeRemoved: 'Az eszköz el lesz távolítva ebből a suite-ból',
  deviceModel: 'Eszközmodell',
  deviceRole: 'Eszköz szerepköre',
  devices: 'Eszközök',
  deviceWillBeMoved:
    'Az eszköz a mentés után a(z) {{destination}} képernyő eszközei közé kerül',
  deviceWillBeMovedToStandby: 'Az eszköz készenléti állapotba kerül',
  disabled: 'Letiltva',
  doNotIncludePrDevices: 'NE tartalmazzon PR eszközöket a KDM generálásához.',
  downloadAttempt: 'Letöltési kísérlet',
  downloadDetails: 'Letöltési részletek',
  downloadHistory: 'Letöltési előzmények',
  downloadKDMs: 'KDM-ek letöltése',
  downloadLocation: 'Letöltési hely',
  downloadNow: 'Letöltés most',
  downloadProgress: '{{progress}} befejezve',
  downloadSize: 'Letöltési méret',
  downloadStatus: 'Letöltési állapot',
  duplicateDeviceFound: 'Duplikált eszköz található',
  duplicateDeviceWarning:
    'Duplikált eszköz található itt: {{screens_and_suites}}',
  editDevice: 'Eszköz szerkesztése',
  editDeviceMeta: 'Eszköz metaadatainak szerkesztése',
  editIp: 'IP szerkesztése',
  editIpHeader: 'IP szerkesztése - {{screen}} képernyő',
  editRoles: 'Szerepkörök szerkesztése',
  editSuite: 'Suite szerkesztése',
  editSuiteHeader: 'Suite szerkesztése: {{screen}} képernyő - {{suite}} Suite',
  editTheatreGroup: 'Mozicsoport szerkesztése',
  effectiveFrom: 'Hatályos ettől:',
  email: 'E-mail',
  emailKDMS: 'E-mail KDM-ek',
  emptyScreen: 'Nincs suite hozzáadva a képernyőhöz',
  emptyStandby: 'Nincsenek eszközök készenlétben',
  enabled: 'Engedélyezve',
  enterEmail: 'Adja meg az e-mail-címet',
  enterGateway: 'Adja meg az átjárót',
  enterIpAddress: 'Adja meg az IP-címet',
  enterSoftwareVersion: 'Adja meg a szoftververziót',
  enterSubnetMask: 'Adja meg az alhálózati maszkot',
  errorDownloadingKDMs: 'Hiba a KDM letöltése során',
  errorFetching: 'Hiba az adatok lekérése közben',
  errorFetchingDevices: 'Hiba az eszközök lekérése közben',
  errorFetchingFilterSettings: 'Hiba a szűrőbeállítások lekérése közben',
  errorFetchingGroups: 'Hiba a csoportok listájának betöltésekor',
  errorFetchingUser: 'Hiba a felhasználói adatok betöltésekor',
  errorFetchingUsersList: 'Hiba a felhasználók listájának betöltésekor',
  errorFetchingWireTapCount: 'Hiba a WireTAP-ok teljes számának betöltésekor',
  errorLoadingWireTap: 'Hiba a WireTAP-ok betöltésekor',
  errorMessage: 'Hiba történt a kérelem feldolgozása során',
  errorReportDownload: 'Hiba a(z) {{report}} jelentés letöltésekor: {{error}}',
  errors: {
    fetchDeviceModels: 'Hiba az eszközmodellek lekérésekor',
    fetchDeviceRoles: 'Hiba az eszközszerepkörök lekérésekor',
    fetchTheatreInfo: 'Hiba a mozis információk lekérésekor',
  },
  errorUploadingCertificate: 'Hiba a tanúsítvány feltöltésekor',
  expandAll: 'Összes kibontása',
  expired: 'Lejárt',
  expiredOn: 'Lejárt ekkor:',
  expiring: 'Lejár ({{days}} nap múlva)',
  expiring_1: 'Lejár',
  expiryOn: 'Lejárat dátuma:',
  failedToDeleteTheatreGroup: 'Nem sikerült törölni a mozicsoportot',
  failedToDeleteTheatreGroupMessage: 'Hiba történt a mozicsoport törlése során',
  failedToRemoveUser: 'Nem sikerült eltávolítani a felhasználót',
  failedToSendUserInvite: 'Nem sikerült elküldeni a felhasználói meghívót',
  failedToUpdateUser: 'Nem sikerült frissíteni a felhasználót',
  fetchCompositions: 'Hiba a kompozíciók betöltésekor',
  fetchingRoles: 'Szerepkörök lekérése...',
  fetchTheatres: 'Hiba a mozik betöltésekor',
  filter: 'Szűrő',
  filterBy: 'Szűrés alapja',
  filterByTheatres: 'Szűrés mozik szerint',
  filterPanelCompositionType: 'KOMPOZÍCIÓ TÍPUSA',
  filterPanelCompositionTypeOptions_advertisement: 'Hirdetés',
  filterPanelCompositionTypeOptions_feature: 'Nagyjátékfilm/Játékfilmek',
  filterPanelCompositionTypeOptions_others: 'Egyebek',
  filterPanelCompositionTypeOptions_psaPolicy: 'PSA/Irányelv',
  filterPanelCompositionTypeOptions_trailerTeaserPromo:
    'Előzetes/Teaser/Promóció',
  filterPanelDcpDownloadStatus: 'DCP LETÖLTÉSI ÁLLAPOT',
  filterPanelDcpIngestStatus: 'DCP BETÖLTÉSI ÁLLAPOT',
  filterPanelKdmIngestStatus: 'KDM BETÖLTÉSI ÁLLAPOT',
  filterPanelKdmStatus: 'KDM KÉZBESÍTÉSI ÁLLAPOT',
  filterPanelKdmValidity: 'KDM ÉRVÉNYESSÉG',
  filterPanelTheatresPlaceHolder: 'Mozik keresése',
  filterPanelTheatresTitle: 'MOZIK',
  filters: 'Szűrők',
  from_time_of_booking: 'a foglalás időpontjától számítva.',
  fullAccess: 'Teljes hozzáférés',
  future: 'Érvényes a jövőben',
  gateway: 'Átjáró',
  generateReport: 'Jelentés generálása',
  groupCount_one: '{{count}} Csoport',
  groupCount_other: '{{count}} Csoport',
  groupName: 'Csoport neve',
  groupsCreateGroupCancel: 'Mégsem',
  groupsCreateGroupCreateTheatreGroups: 'Mozicsoportok létrehozása',
  groupsCreateGroupGroupCreated: 'Csoport létrehozva',
  groupsCreateGroupGroupName: 'Csoport neve',
  groupsCreateGroupGroupPlaceHolderName: 'Adja meg a csoport nevét',
  groupsCreateGroupHeaderTitle: 'Csoport létrehozása',
  groupsCreateGroupSaveChanges: 'Módosítások mentése',
  groupsCreateGroupTheatreSelection: 'Mozi kiválasztása',
  groupsHeaderCreateTheatreGroupButton: 'Mozicsoport létrehozása',
  groupsHeaderViewLogsButton: 'Naplók megtekintése',
  groupUpdated: 'Csoport frissítve',
  holdoverKdmRequests: 'Holdover KDM kérések',
  hour: 'Óra',
  iabScreens: 'IAB képernyők',
  inbox: 'Bejövő levelek',
  invalidEmail: 'Érvénytelen e-mail-cím',
  ipRequired: 'IP-cím megadása kötelező',
  ipAddress: 'IP-cím',
  ipAddress_1: 'IP-CÍM',
  ipAlreadySelectedInForm:
    'Ez az IP már ki van választva/rendelve. Kérjük, válasszon egy másik IP-címet.',
  ipCount_one: 'IP-k (1)',
  ipCount_other: 'IP-k ({{count}})',
  kdmDetails: 'KDM Részletek',
  kdmValidityTheatreTimeZone: 'KDM Érvényesség (Mozi időzónája)',
  lastUpdatedBy: 'Utolsó frissítés:',
  lastUpdatedOn: 'Utolsó frissítés:',
  linkExpiredOnDownload:
    'A letöltést nem lehet elindítani. A kézbesítési hivatkozás lejárt, vagy már nem jogosult a letöltésre.',
  linkReceivedOn: 'Hivatkozás érkezett:',
  loading: 'Betöltés',
  location: 'Hely',
  logsTheatreGroups: 'Naplók: Mozicsoportok',
  minute: 'Perc',
  moveModalText: 'A(z) {{name}} eszköz készenléti állapotba kerül, folytatja?',
  moveTo: 'Áthelyezés ide:',
  moveToScreen: '{{number}} képernyő',
  moveToStandby: 'Áthelyezés készenlétbe',
  moveToStandbyDevices: 'Áthelyezés a Készenléti eszközök közé',
  moveToUnmapped: 'Áthelyezés a(z) {{number}} képernyő eszközei közé',
  movie: 'Film',
  movieName: 'Film neve',
  multiThumbprintKdm:
    'Több ujjlenyomatú KDM képernyők DC2 (DCP 2000) szerverrel',
  multiThumbprintKdmOtherServices:
    'Több ujjlenyomatú KDM képernyők más szerverekkel',
  name: 'Név',
  needs_1_SM_RMB_msg:
    'Minden suite-nak pontosan 1 SM/1 RMB-t kell tartalmaznia. Kérjük, adja hozzá a tanúsítvánnyal rendelkező SM/RMB eszközt a folytatáshoz',
  newData: 'Új adatok',
  newRequestCreated:
    'Új kérelem jött létre a következő azonosítóval: {{requestId}}.',
  no_compositions: 'Nincsenek kompozíciók',
  no_theatres: 'Nincsenek elérhető mozik',
  noAccess: 'Nincs hozzáférés',
  noBookings: 'Nincsenek elérhető foglalások',
  noData: 'Nincsenek adatok',
  noExpiredBookings: 'Nem találhatók lejárt WireLink letöltések.',
  noIpFound: 'Nincsenek elérhető IP-k',
  noMatchFound: 'Nincs találat',
  noResultsFound: 'Nincs találat',
  normalKdm: 'Normál KDM',
  notDownloaded: 'Nincs letöltve',
  notSelected: 'Nincs kiválasztva',
  noWiretapAvailable: 'Nincsenek elérhető WireTAP-ok',
  oldData: 'Régi adatok',
  optional: 'Opcionális',
  osVersion: 'Operációs rendszer verziója',
  pending: 'Függőben',
  readyToDownload: 'Készen áll a letöltésre',
  receivedOn: 'Érkezett:',
  recipientDetails: 'Címzett részletei',
  recipientEmails: 'Címzett e-mailek',
  remove: 'Eltávolítás',
  removeFromTheatre: 'Eltávolítás a moziból',
  removeModalText:
    'Biztosan el szeretné távolítani a(z) {{name}} elemet a moziból?',
  removeUser: 'Felhasználó eltávolítása',
  removeUserConfirmation:
    'A felhasználó eltávolítása törli a hozzáférését ebből a vállalatból. A felhasználó nem fog tudni bejelentkezni és semmilyen műveletet végrehajtani.',
  reportInitiated: 'A(z) {{report}} folyamata elindult.',
  reportReady: 'A(z) {{report}} elkészült.',
  reportsheaderTitle: 'Jelentések',
  requestedBy: 'Kérte',
  requestedKdmValidity: 'Kért KDM-érvényesség',
  requestedOn: 'Kért',
  requestFailed: 'Kérés sikertelen',
  requestFailedMessage: 'Nem sikerült elküldeni a kérést. Próbálja újra.',
  requestSent: 'Kérés elküldve',
  role: 'Szerepkör',
  roles: 'Szerepkörök',
  save: 'Mentés',
  saveChanges: 'Módosítások mentése',
  screen: 'Képernyő',
  screenInactive: 'Inaktív',
  screens: 'Képernyők',
  searchByLocation: 'Keresés hely szerint',
  searchByNameOrEmail: 'Keresés név vagy e-mail alapján',
  searchBySerialNo: 'Keresés sorozatszám alapján',
  searchByTheatreGroup: 'Keresés mozicsoport alapján',
  searchByTheatreGroupName: 'Keresés mozicsoport neve alapján',
  searchByTheatreName: 'Keresés mozi neve alapján',
  searchCompositions: 'Keresés kompozíció neve alapján',
  searchCompositionsPlaceholder: 'Kompozíciók keresése',
  searchDeviceModel: 'Eszközmodell keresése',
  searchForChain: 'Lánc keresése',
  searchForLocation: 'Hely keresése',
  searchForOsVersion: 'OS-verzió keresése',
  searchForPublicIp: 'Nyilvános IP keresése',
  searchForSerialNumber: 'Sorozatszám keresése',
  searchForTheatre: 'Mozi keresése',
  searchForWiretap: 'WireTAP keresése',
  searchMovies: 'Keresés film neve alapján',
  searchPlaceholder: 'Keressen az Ön által kezelt mozik között',
  searchSerialNumber: 'Sorozatszám keresése',
  searchTheatres: 'Mozik keresése',
  selectIpAddress: 'Válasszon IP-címet',
  selectRole: 'Válasszon szerepkört',
  sendInvite: 'Meghívó küldése',
  serialNumber: 'Sorozatszám',
  serialNumber_1: 'SOROZATSZÁM',
  show: 'Megjelenítés',
  showingCountResults_one: '1 találat megjelenítése a következőre:',
  showingCountResults_other: '{{count}} találat megjelenítése a következőre:',
  showingResults: '{{start}}-{{end}} / {{total}} elem megjelenítése',
  showingResultsFor: 'Eredmények megjelenítése a következőre:',
  showMore: 'Továbbiak megjelenítése',
  softwareVersion: 'Szoftververzió',
  somethingWentWrong: 'Valami hiba történt!',
  standby: 'Készenlét',
  standbyDevices: 'Készenléti eszközök',
  standbyHeader_one: 'Készenléti eszközök (1)',
  standbyHeader_other: 'Készenléti eszközök ({{count}})',
  status: 'Állapot',
  subnetMask: 'Alhálózati maszk',
  suite: 'Suite',
  suiteCreationRules: 'Suite létrehozási szabályok',
  suiteDevicesExpiredMsg:
    'A suite lejárt tanúsítvánnyal rendelkező eszközöket tartalmaz',
  suiteEffectiveFrom: 'Suite hatályossága ettől:',
  suiteInvalid: 'A suite érvénytelen a KDM generálásához',
  suiteLogs: 'Suite naplók',
  suiteMustContain:
    'A suite-nak pontosan {{smCount}} SM vagy {{rmbCount}} RMB eszközt kell tartalmaznia.',
  suiteMustContainAdLd:
    'A suite-nak tartalmaznia kell legalább 1 további eszközt LD szerepkörrel',
  suiteMustContainLDorPR:
    'A suite-nak tartalmaznia kell legalább 1 további eszközt LD vagy PR szerepkörrel.',
  suiteMustContainSm:
    'A suite-nak pontosan {{smCount}} SM eszközt kell tartalmaznia.',
  suiteMustContainSMOBE:
    'A suite-nak pontosan 1 SM / OBAE-t kell tartalmaznia SM eszközzel.',
  suiteNo: '{{number}} Suite',
  theatre: 'Mozi',
  theatre_1: 'MOZI',
  theatre_header: 'Mozi',
  theatreCount: 'Mozik száma',
  theatreGroup: 'Mozicsoport',
  theatreGroupDeleted: 'Mozicsoport törölve',
  theatreGroupDeletedMessage: 'A(z) {{groupName}} törölve lett',
  theatreGroupDetails: 'Mozicsoport részletei',
  theatreGroups: 'Mozicsoportok',
  theatreName: 'Mozi neve',
  theatres: 'Mozik',
  theatresList: 'Mozik listája',
  theatreSmall: 'Mozi',
  theatreTimeZone: 'Mozi időzónája',
  trackingInfo: 'Követési információk',
  unarchival_may_take: 'Az archiválás visszaállítása eltarthat',
  undo: 'Visszavonás',
  unmappedDevices_one: 'Eszköz (1)',
  unmappedDevices_other: 'Eszközök ({{count}})',
  untitled: 'Névtelen',
  update: 'Frissítés',
  updatedBy: 'Frissítette:',
  updatedOn: 'Frissítve:',
  uploadCertificate: 'Tanúsítvány feltöltése',
  uploadDeviceCertificate: 'Eszköztanúsítvány feltöltése',
  user: 'Felhasználó',
  userCount_one: '{{1}} Felhasználó',
  userCount_other: '{{count}} Felhasználó',
  userInviteSent: 'Felhasználói meghívó sikeresen elküldve',
  userLogs: 'Felhasználói naplók',
  userRemoved: 'Felhasználó eltávolítva',
  users: 'Felhasználók',
  usersHeaderButtonsInviteUser: 'Felhasználó meghívása',
  usersHeaderButtonsViewLogs: 'Naplók megtekintése',
  usersHeaderTitle: 'Felhasználók kezelése',
  validFrom: 'Érvényes ettől',
  validNow: 'Jelenleg érvényes',
  validTo: 'Érvényes eddig',
  verificationStatus: 'Ellenőrzési állapot',
  viewAll: 'Összes megtekintése',
  viewAllTheatreGroups: 'Összes mozicsoport megtekintése',
  viewCreditOffset: 'Kreditek: {{value}}',
  viewSuiteLogs: 'Suite naplók megtekintése',
  viewTheatreGroup: 'Mozicsoport megtekintése',
  warning: 'Figyelmeztetés',
  wireLinkCopiedToClipboard: 'WireLink másolva a vágólapra',
  wireLinkCopyFailed: 'Sikertelen másolás. Kérjük, próbálja újra',
  wireLinkDetails: 'WireLink részletei',
  wireLinks: 'WireLinks',
  wiretaps: 'WireTAP-ok',
  wiretapStatusReport: 'WireTAP állapotjelentés',
  removeDevice: 'Eszköz eltávolítása',
  deleteIpTitle: 'IP-cím törlése - {{ip}}',
  appliances: 'Eszközök',
  noResultsFor: 'Nincs találat erre',
  city: 'Város',
  province: 'Megye',
  country: 'Ország',
  confirmAction: 'Művelet megerősítése',
  RequestId: 'Kérelem azonosító: {{requestId}}',
  moveToUnmapped_name: 'Áthelyezés a {{name}} eszközökhöz',
  language: 'Nyelv',
  subtitleLanguage: 'Felirat nyelve',
  mainCaption: 'Fő felirat',
  ratings: 'Értékelések',
  type: 'Típus',
  dciStandard: 'DCI szabvány',
  closedSubtitles: 'Zárt feliratok',
  frameRate: 'Képkockasebesség',
  audioFormats: 'Hangformátumok',
  resolution: 'Felbontás',
  closedCaptions: 'Zárt feliratok',
  stereoType: 'Sztereó típus',
  aspectRatio: 'Képarány',
};
